module.exports = __webpack_public_path__ + "static/media/gutter_only_sprite.5177c915.png";